module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "transaction-sort-title small-container",
    on: {
      "click": _vm.handleSortStrategy
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle()
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-711db862","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/SortableTh.vue
// module id = 2171
// module chunks = 1